import {Store, Module, ActionContext} from 'vuex'
import PageResult from '@/store/entities/page-result';
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import CustomerType from '../entities/customer-types/customer-type'
interface CustomerTypeState extends ListState<CustomerType>{
}
class CustomerTypeModule extends ListModule<CustomerTypeState,any,CustomerType>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<CustomerType>(),
        loading:false
    }
    actions={
        async getAll(context: ActionContext<CustomerTypeState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/CustomerType/GetAll', { params: payload.data });
            context.state.loading = false;
            const page = result as PageResult<CustomerType>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async get(context:ActionContext<CustomerTypeState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/CustomerType/GetDetail?Id='+payload.data.id);
            return reponse.data.result as CustomerType;
        },
        async create(context: ActionContext<CustomerTypeState, any>, payload: any) {
            await Ajax.post('/api/services/app/CustomerType/Create', payload.data);
        },
        async update(context: ActionContext<CustomerTypeState, any>, payload: any) {
            await Ajax.put('/api/services/app/CustomerType/Update', payload.data);
        },
        async getCustomerType(context: ActionContext<CustomerTypeState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/CustomerType/GetCustomerType', { params : payload.data });
            return reponse.data.result.items as CustomerType[];
        },
    };
    mutations={
        setCurrentPage(state:CustomerTypeState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:CustomerTypeState,pagesize:number){
            state.pageSize=pagesize;
        }
    }
}
const customerTypeModule=new CustomerTypeModule();
export default customerTypeModule;